var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 35,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#199b8b",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3157 15.5611L16.9496 14.2002C17.0736 13.934 16.9617 13.6209 16.6928 13.4815L15.7537 12.9948C15.5214 12.8744 14.6252 12.4743 14.3833 12.5746L13.0091 13.3349L12.7334 13.1722C12.1405 12.8169 11.3796 12.3564 10.8319 11.8472C10.608 11.639 10.5787 11.3162 10.7188 11.0497L11.1768 10.1784C11.2588 9.99259 10.8198 9.04045 10.5134 8.44999C10.3648 8.16364 10.0593 8 9.72355 8L9.00396 8C8.34678 8 7.72187 8.28317 7.28471 8.77386C7.18886 8.88144 7.10635 8.97356 7.05707 9.02757C7.02839 9.059 7.00426 9.09411 6.98632 9.13269V9.13269C6.67141 9.80981 6.56917 10.5852 6.86243 11.2719C7.98128 13.8921 10.671 15.7533 13.8212 16.6786C14.5199 16.8838 16.0195 16.197 16.3157 15.5611Z",
    stroke: "#199b8b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C10.5124 21 9.10904 20.6391 7.8728 20C7.10187 19.6015 4.12089 21.5948 3.5 21C2.88698 20.4128 4.6319 17.2397 4.20404 16.5C3.43827 15.1762 3 13.6393 3 12Z",
    stroke: "#199b8b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappSvgrepoCom);
export default __webpack_public_path__ + "static/media/whatsapp-svgrepo-com.4930ccdf198d92cd08d7e58de79763ad.svg";
export { ForwardRef as ReactComponent };